import airbrake from '../airbrake';

class Landing {
    init() {
        $('a').on('click', function (event) {
            if (this.hash !== '') {
                event.preventDefault();
                var hash = this.hash;
                $('html, body').animate({
                    scrollTop: $(hash).offset().top,
                }, 800, function () {
                    window.location.hash = hash;
                });
            }
        });

        $('section#testimoniosMovil .carousel').slick({
            dots: false,
            fade: false,
            arrows: false,
            centerMode: true,
            centerPadding: '40px',
            slidesToShow: 1,
        });

        $('section#testimonios .carousel').slick({
            dots: true,
            prevArrow: '.circulitoIzq',
            nextArrow: '.circulitoDer',
        });

        $(window).on('load resize scroll', function () {
            var scroll = $(this).scrollTop() > 30;
            if (!$('#barraNavegadora').hasClass('scrolleado')) {
                $('#barraNavegadora').toggleClass('scrolleado', scroll);
            } else {
                if ($(window).scrollTop() <= 30 && $('.navbar-toggler').attr('aria-expanded') === 'false') {
                    $('#barraNavegadora').toggleClass('scrolleado');
                }
            }
        });

        $('.navbar-toggler').on('click', function () {
            if ($(window).scrollTop() <= 30) {
                $('#barraNavegadora').toggleClass('scrolleado');
            }
        });

        $('#toggleSwitch').change(function () {
            $('.beneficios-incluidos').toggle(this.checked);
            $('.beneficios-excluidos').toggle(!this.checked);
        });
    }
}

airbrake.call(() => $(document).ready(() => new Landing().init()));
